import { types, Instance } from 'mobx-state-tree';
// Persistence disabled - logs are ephemeral
import { makeAutoObservable } from 'mobx';

const Position = types.model('Position', {
  x: types.number,
  y: types.number,
});

const Size = types.model('Size', {
  width: types.number,
  height: types.number,
});

export const LogsStore = types
  .model('LogsStore', {
    debugLogsPosition: types.optional(Position, { x: 10, y: 10 }),
    databaseLogsPosition: types.optional(Position, { x: 10, y: 300 }),
    debugControlsPosition: types.optional(Position, { x: 500, y: 80 }), // Default position
    debugControlsSize: types.optional(Size, { width: 400, height: 500 }),
    lastExpandedSize: types.optional(Size, { width: 400, height: 500 }),
    isDatabaseLogsCollapsed: types.boolean,
    isDebugLogsCollapsed: types.boolean,
    isDebugControlsCollapsed: types.boolean,
    presenceLogs: types.optional(types.array(types.string), []),
    maxPresenceLogs: types.optional(types.number, 200)
  })
  .views((self) => ({
    get currentControlsSize() {
      return self.isDebugControlsCollapsed 
        ? { width: 400, height: 40 } 
        : self.lastExpandedSize;
    }
  }))
  .actions((self) => ({
    setDebugLogsPosition(position: { x: number; y: number }) {
      self.debugLogsPosition = position;
    },
    setDatabaseLogsPosition(position: { x: number; y: number }) {
      self.databaseLogsPosition = position;
    },
    setDebugControlsPosition(position: { x: number; y: number }) {
      self.debugControlsPosition = position;
    },
    setDebugControlsSize(size: { width: number; height: number }) {
      if (!self.isDebugControlsCollapsed) {
        self.lastExpandedSize = size;
      }
    },
    toggleDebugControlsCollapsed() {
      self.isDebugControlsCollapsed = !self.isDebugControlsCollapsed;
    },
    toggleDatabaseLogsCollapsed() {
      self.isDatabaseLogsCollapsed = !self.isDatabaseLogsCollapsed;
    },
    toggleDebugLogsCollapsed() {
      self.isDebugLogsCollapsed = !self.isDebugLogsCollapsed;
    },
    addPresenceLog(message: string) {
      self.presenceLogs.unshift(`[${new Date().toLocaleTimeString()}] ${message}`);
      if (self.presenceLogs.length > self.maxPresenceLogs) {
        self.presenceLogs.splice(self.maxPresenceLogs);
      }
    },
    clearPresenceLogs() {
      self.presenceLogs.clear();
    }
  }));

export interface ILogsStore extends Instance<typeof LogsStore> {}

// REMOVED: No longer creating a singleton instance here. AppStore is responsible.
// const logsStore = LogsStore.create({
//   debugLogsPosition: { x: 10, y: 10 },
//   databaseLogsPosition: { x: 10, y: 300 },
//   debugControlsPosition: { x: window.innerWidth - 420, y: 80 },
//   debugControlsSize: { width: 400, height: 500 },
//   lastExpandedSize: { width: 400, height: 500 },
//   isDatabaseLogsCollapsed: false,
//   isDebugLogsCollapsed: false,
//   isDebugControlsCollapsed: false,
//   presenceLogs: [],
//   maxPresenceLogs: 200
// });

// DISABLED persistence to prevent MST reference conflicts
// persist('logs', logsStore, {
//   storage: localStorage,
//   jsonify: true,
//   whitelist: [
//     'debugLogsPosition',
//     'databaseLogsPosition',
//     'debugControlsPosition',
//     'debugControlsSize',
//     'lastExpandedSize',
//     'isDatabaseLogsCollapsed',
//     'isDebugLogsCollapsed',
//     'isDebugControlsCollapsed'
//   ]
// });

// export { logsStore }; 